import React from "react";
import LpcAvatar from "@/shared/avatar/LpcAvatar";
import BuddyAvatar from "@/shared/avatar/BuddyAvatar";
import { useUserAvatar } from "@/shared/avatar/userAvatar";
import type { LpcAvatarProps } from "@/shared/avatar/LpcAvatar";

// Agents draw from their saved seed alone. `hue` stays on the signature for its many callers:
// it is still saved with the agent's identity, but buddies are ink, so it is not drawn.
export interface PixelAvatarProps extends LpcAvatarProps {
  hue?: number;
}

export default function PixelAvatar({ human, seed, avatar, hue: _hue, ...props }: PixelAvatarProps) {
  const user = useUserAvatar();
  const isHuman = human ?? (!!seed && seed === user.seed);
  if (!isHuman) return <BuddyAvatar seed={seed} {...props} />;
  return <LpcAvatar seed={seed} human avatar={avatar ?? user.avatar} {...props} />;
}
